import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EnquiryForm = class EnquiryForm extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-enquiry-form';
    }

    constructor(element) {
        super(element);

        $(".scrollTo").on('click',
            function(e) {
                e.preventDefault();
                var target = $(this).attr('href');
                $('html, body').animate({
                        scrollTop: ($(target).offset().top - 150)
                    },
                    800);
            });

    }

    render() {
        this.setVars();
        this.addEventListeners();
    }

    setVars() {
        this.$form = this.$element.find('.fa-enquiry-form__form');
        this.$messageContainer = this.$element.find('.message-container');
        this.errorClass = 'fa-input-field--error';
        this.messageClass = 'fa-input-field__error-message';
    }

    addEventListeners() {
        this.$form.on('submit', this.onFormSubmission.bind(this));
    }

    onFormSubmission(event) {
        event.preventDefault();

        // check if recaptcha is valid
        this.isRecaptchaValid();

        if ($("#g-recaptcha-response").val() === '') {
            return false;
        }

        var innerCircleBool = false;
        if ($('#membership_Inner_Circle') && $('#membership_Inner_Circle:checked').length !== 0) {
            innerCircleBool = true;
        }

        var bobbyMooreBool = false;
        if ($('#membership_Bobby-Moore') && $('#membership_Bobby-Moore:checked').length !== 0) {
            bobbyMooreBool = true;
        }

        var membership_Centre_CircleBool = false;
        if ($('#membership_Centre_Circle') && $('#membership_Centre_Circle:checked').length !== 0) {
            membership_Centre_CircleBool = true;
        }

        var oneTwentyBool = false;
        if ($('#membership_One_Twenty') && $('#membership_One_Twenty:checked').length !== 0) {
            oneTwentyBool = true;
        }

        var membership_No9Bool = false;
        if ($('#membership_No9') && $('#membership_No9:checked').length !== 0) {
            membership_No9Bool = true;
        }

        var privateBoxBool = false;
        var privateBoxNumber = "";
        if ($('#membership_Private_Boxes') && $('#membership_Private_Boxes:checked').length !== 0) {
            privateBoxBool = true;
            if ($('#seats-field') && $('#seats-field option:selected').length !== 0) {
                privateBoxNumber = $('#seats-field option:selected').val();
            }
        }

        if ($('#membership_0') && $('#membership_0:checked').length !== 0) {
            oneTwentyBool = true;
            bobbyMooreBool = true;
            innerCircleBool = true;
            //privateBoxBool = true;
            membership_Centre_CircleBool = true;
            membership_No9Bool = true;
        }

        var eventsInterest = "";
        if ($('#event-title')) {
            eventsInterest = $("#event-title :selected").text();
            if ($("#event-title :selected").val() == "0") {
                eventsInterest = "";
            }
        }

        var offersUpdatesFieldVal = false;
        if ($('#offersUpdatesField') && $('#offersUpdatesField:checked').length !== 0) {
            offersUpdatesFieldVal = true;
        }

        var gdprConsentField = false;
        if ($('#gdprConsentField') && $('#gdprConsentField:checked').length !== 0) {
            gdprConsentField = true;
        }

        var preferredContactEmail = false;
        if ($('#email-contact') && $('#email-contact:checked').length !== 0) {
            preferredContactEmail = true;
        }

        var preferredContactPhone = false;
        if ($('#phone-contact') && $('#phone-contact:checked').length !== 0) {
            preferredContactPhone = true;
        }

        var formData = {
            Title: { FieldName: "titleField", FieldValue: $("#title-field :selected").val() },
            FirstName: { FieldName: "firstNameField", FieldValue: $("#firstName-field").val() },
            LastName: { FieldName: "lastNameField", FieldValue: $("#lastName-field").val() },
            EmailAddress: { FieldName: "emailField", FieldValue: $("#email-field-main").val() },
            PhoneNumber: { FieldName: "telephoneField", FieldValue: $("#telephone-field").val() },
            Company: { FieldName: "companyField", FieldValue: $("#company-field").val() },
            Enquiry: { FieldName: "enquiryField", FieldValue: $("#enquiry-field").val() },
            AgeRange: { FieldName: "ageField", FieldValue: $("#age-field :selected").val() },
            Postcode: { FieldName: "postcodeField", FieldValue: $("#postcode-field").val() },
            InnerCircle: innerCircleBool,
            BobbyMoore: bobbyMooreBool,
            OneTwenty: oneTwentyBool,
            CentreCircle: membership_Centre_CircleBool,
            No9: membership_No9Bool,
            PrivateBox: privateBoxBool,
            PrivateBoxNumber: { FieldName: "seatsField", FieldValue: privateBoxNumber },
            EventsInterest: { FieldName: "eventTitleField", FieldValue: eventsInterest },
            ReceiveOffers: offersUpdatesFieldVal,
            PreferredContactEmail: preferredContactEmail,
            PreferredContactPhone: preferredContactPhone,
            GDPRConsent: gdprConsentField
        };

        $.ajax({
                beforeSend: function() {
                    $('.loading-message-wrapper').removeClass('hide').addClass('show');
                },
                url: this.formAction = this.$form.attr('action'),
                method: this.formMethod = this.$form.attr('method'),
                data: this.formData = formData
            })
            .always(this.handleValidationResponse.bind(this));
    }

    handleValidationResponse(response) {
        this.hideAllValidationErrors();
        if (!response.success) {
            $('html, body').animate({
                    scrollTop: ($('.form-title').offset().top)
                },
                800);

            $.each(response.fields,
                (i, field) => {
                    this.showValidationError(field);
                    const activeClass = 'active';

                    //this.resetForm();
                    this.$messageContainer.removeClass(activeClass);
                    $(".loading-message-wrapper").delay(500).queue(function(next) {
                        $(this).removeClass('show').addClass('hide');
                        next();
                    });
                });
        } else {
            this.handleSuccess(response);
        }
    }

    hideAllValidationErrors() {
        $(".fa-input-field--error").each(function() {
            $(this).removeClass("fa-input-field--error");
        });
    }

    showValidationError(field) {
        const $element = this.$form.find(`[name=${field.FieldName}]`);

        $element
            .addClass(this.errorClass)
            .parent()
            .addClass(this.errorClass)
            .find(`.${this.messageClass}`).text(field.Reason);
    }

    removeValidationError(field) {
        const $element = this.$form.find(`[name=${field.element}]`);

        $element
            .removeClass(this.errorClass)
            .parent()
            .removeClass(this.errorClass)
            .find(`.${this.messageClass}`).text('');
    }

    handleSuccess(response) {

        dataLayer.push({ 'crmUserId': response.CrmUserId });
        dataLayer.push({ 'thankYouURL': window.location.href + '/thankyou' });

        window.location.replace("/membershipconfirmation");
    }

    isRecaptchaValid() {
        const recaptcha = $("#g-recaptcha-response").val();
        const recaptchaError = document.querySelectorAll('.recaptcha-error')[0];

        if (recaptcha === "") {
            recaptchaError.innerHTML = 'Please check the recaptcha';
            recaptchaError.style.display = 'block';
        } else {
            recaptchaError.style.display = 'none';
        }
    }

    resetForm() {
        this.$form.find('input, select, textarea').each((i, element) => {
            element.value = '';
        });
    }
}

$(function() {
    new Snappy.Component.EnquiryForm();

    $('#membership_0').change(function() {
        if ($(this).is(":checked")) {
            $('.membershipCheckbox').each(function() {
                $(this).prop('checked', false);
            });
        }
    });

    $('.membershipCheckbox').change(function() {
        if ($(this).hasClass("nonDefault")) {
            if ($(this).is(":checked")) {
                $('#membership_0').prop('checked', false);
            }
        }
    });

    $('#membership_Private_Boxes').change(function() {
        $('#fa-dropdown--seats').toggleClass("hide");
    });


    //Event Dropdown
    var defaultDescription = $('ul.fa-dropdown-content li.description-default');
    var eventDescription = $('ul.fa-dropdown-content li.description');

    $(eventDescription).hide();
    $(defaultDescription).show();

    $('.fa-dropdown select#event-title').change(function() {
        $(defaultDescription).hide();
        $(eventDescription).hide();
        $('#' + this.value).show();

        if ($(this).val() == '0') {
            $(defaultDescription).show();
        }
    });
});



// WEBPACK FOOTER //
// ./components/cw-enquiryForm/scripts/enquiryForm.js